import {MithrilComponent} from '@bitstillery/mithril'
import {Notification} from '@bitstillery/common/components/ui/notification/notification'
import m from '@bitstillery/mithril'

import type {NotificationData} from './notifier'

interface NotificationGroupAttrs {
    notifications: NotificationData[]
}

export class NotificationGroup extends MithrilComponent<NotificationGroupAttrs> {
    notifications: NotificationData[]

    constructor(vn: m.Vnode<NotificationGroupAttrs>) {
        super()
        this.notifications = vn.attrs.notifications
    }

    on_close(notification: NotificationData) {
        this.notifications.splice(
            this.notifications.findIndex((i) => i.id === notification.id),
            1,
        )
    }

    view(vn: m.Vnode<NotificationGroupAttrs>) {
        return (
            <div className='c-notifications'>
                {vn.attrs.notifications.map((notification: NotificationData) => (
                    <Notification
                        notification={notification}
                        on_close={this.on_close.bind(this)}
                        {...(notification.id === undefined ? {} : {key: notification.id})}
                    />
                ))}
                {vn.children}
            </div>
        )
    }
}
